export const ANIMATION_GAP = 40;
export const ANIMATION_DURATION = 180;
